import React, { useState } from 'react';
import { translate } from '../../../Services/translation';
import Modal from '../../Components/Modal/Modal';
import ModalContainerComponent from '../../Components/Modal/ModalContainerComponent';

const InvestmentPage = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  let pressReleaseList = '';
  let contactList = '';
  let timePlanList = '';

  const isMobileDevice = window.innerWidth <= 600;
  const result = props.result.length > 0 ? props.result[0] : {};
  const {
    modalTitle,
    modalText,
    modalCountry,
    modalCurrentCountry,
    modalTermsText,
  } = result;

  if (props.result.length > 0) {
    pressReleaseList = props.result[0].pressRelease;
    contactList = props.result[0].contactList;
    timePlanList = props.result[0].timePlanList;
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  function createPressRelease() {
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    if (pressReleaseList.length > 0) {
      return pressReleaseList.map((pressRelease, index) => {
        const publishDate = new Date(pressRelease.publishDate);
        const isPublished = pressRelease.publishDate !== '0001-01-01T00:00:00';
        const formatter = new Intl.DateTimeFormat('nl-NL', options);
        const formattedDate = formatter.format(publishDate);

        const [
          formattedDay,
          formattedMonth,
          formattedYear,
        ] = formattedDate.split(' ');

        return (
          <div key={index} className="pressReleaseItem">
            <div className="pressReleaseItem__container">
              <p className="pressReleaseItem__container--title">
                {pressRelease.title}
              </p>
              <p className="pressReleaseItem__container--subtitle">
                {pressRelease.subtitle}
              </p>
              {isPublished && (
                <p className="pressReleaseItem__container--date">{`${formattedDay} ${formattedMonth}, ${formattedYear}`}</p>
              )}
            </div>
            {pressRelease.file && (
              <div className="fileContainer">
                <a
                  className="fileContainer__download-link"
                  href={pressRelease.file.url}
                  download={pressRelease.file.filename}
                  target="_blank"
                  rel="noreferrer"
                >
                  {translate('investment-page-download')}
                </a>
                <span></span>
              </div>
            )}
          </div>
        );
      });
    }
  }

  function createTimePlan() {
    if (timePlanList.length > 0) {
      return timePlanList.map((timePlanList, index) => (
        <div key={index} className="timePlanContainer--item-container--item">
          <span></span>
          <div className="timePlanContainer--item-container--item--text">
            <p className="timePlanContainer--item-container--item--text--title">
              {timePlanList.planText}
            </p>
            <p className="timePlanContainer--item-container--item--text--date">
              {timePlanList.scheduledDate}
            </p>
          </div>
        </div>
      ));
    }
  }

  function createContact() {
    if (contactList.length > 0) {
      return contactList.map((contactList, index) => (
        <div key={index} className="contact-container__item--container">
          <p className="contact-container__item--container--name">
            {contactList.contactName}
          </p>
          <p className="contact-container__item--container--position">
            {contactList.contactPosition}
          </p>
          <p className="contact-container__item--container--phone">
            {isMobileDevice ? (
              <a href={`tel:${contactList.contactPhone}`}>
                {contactList.contactPhone}
              </a>
            ) : (
              contactList.contactPhone
            )}
          </p>
          <p className="contact-container__item--container--email">
            <a href={`mailto:${contactList.contactEmail}`}>
              {contactList.contactEmail}
            </a>
          </p>
        </div>
      ));
    }
  }

  return (
    <div>
      {props.result.length > 0 && (
        <div>
          {isModalOpen && (
            <Modal
              childComponent={ModalContainerComponent}
              modalTitle={modalTitle}
              modalText={modalText}
              modalCountry={modalCountry}
              modalCurrentCountry={modalCurrentCountry}
              modalTermsText={modalTermsText}
              onClose={handleCloseModal}
            />
          )}
          {!isModalOpen && (
            <div className="grid-system grid-system-within-boundaries">
              <div className="grid-full-width short-text-block__container">
                <div className="pressReleaseContainer">
                  {createPressRelease()}
                </div>
                {timePlanList.length > 0 && (
                  <div className="timePlanContainer">
                    <div className="timePlanContainer--title">
                      {translate('investment-time-plane-title')}
                    </div>
                    <div className="timePlanContainer--item-container">
                      {createTimePlan()}
                    </div>
                  </div>
                )}
                {contactList.length > 0 && (
                  <div className="contact-container">
                    <div className="contact-container__header">
                      <p className="contact-container__header--title">
                        {translate('investment-contact-title')}
                      </p>
                      <p className="contact-container__header--text-title">
                        {translate('investment-contact-text-title')}
                      </p>
                      <p className="contact-container__header--text">
                        {translate('investment-contact-text')}
                      </p>
                    </div>
                    <div className="contact-container__item">
                      {createContact()}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InvestmentPage;
